import { render } from "./MdUpdateAffiliates.vue?vue&type=template&id=236c132a&scoped=true"
import script from "./MdUpdateAffiliates.vue?vue&type=script&lang=js"
export * from "./MdUpdateAffiliates.vue?vue&type=script&lang=js"

import "./MdUpdateAffiliates.vue?vue&type=style&index=0&id=236c132a&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c132a"]])

export default __exports__